document.addEventListener('DOMContentLoaded', () => {
    function disableEnterOnInput(input) {
        input.addEventListener('keypress', e => {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    function init(el) {
        const email = el.querySelector('[data-iso-availability-alarm-email]');
        const submit = el.querySelector('[data-iso-availability-alarm-submit]');
        const success = el.querySelector('[data-iso-availability-alarm-success]');
        const error = el.querySelector('[data-iso-availability-alarm-error]');

        if (!email || !submit || !success || !error) {
            return;
        }

        // Disable the "Enter" key press on inputs
        disableEnterOnInput(email)

        submit.addEventListener('click', e => {
            e.preventDefault();

            el.classList.add('ajax-loading');
            error.innerHTML = '';
            success.innerHTML = '';
            email.disabled = true;
            submit.disabled = true;

            fetch(el.dataset.isoAvailabilityAlarm, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: `email=${email.value}`,
            })
                .then(response => {
                    response.text().then(text => {
                        if (response.status === 200) {
                            success.innerHTML = text;
                            email.value = '';
                        } else {
                            error.innerHTML = text;
                        }
                    })
                })
                .finally(() => {
                    email.disabled = false;
                    submit.disabled = false;
                    el.classList.remove('ajax-loading');
                })
            ;
        });
    }

    document.querySelectorAll('[data-iso-availability-alarm]').forEach(init);
});
